export default {
    title: 'Poruke',
    messages: 'poruka',
    leaveReply: 'Ostavite odgovor',
    searchMessages: 'Pretraži poruke',
    filter: {
        allMessages: 'Sve poruke',
        unreadMessages : 'Nepročitane poruke',
        orders: 'Narudžbine',
        unreadOrders: 'Nepročitane narudžbine'
    },
    sidebar: {
        order: 'Narudžbina'
    },
    chatHeader: {
        orderNumber: 'Broj narudžbine'
    },
    modal: {
        askSellerAQuestion: 'Postavi pitanje prodavcu',
        sendCustomerMessage: 'Pošalji poruku kupcu'
    }
};
